import React from "react";
import { Link } from "react-router-dom";
import { DownloadIcon } from "lucide-react";
import { useSeo } from "../hooks/useSeo";
import { PageHero } from "../components/ui/PageHero";
import { SITEMAP_GROUPS } from "../data/routes";
import { SITE } from "../data/site";
function downloadXml() {
  const urls = SITEMAP_GROUPS.flatMap(g => g.links.map(l => l.href));
  const xml = `<?xml version="1.0" encoding="UTF-8"?>\n<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n${urls.map(u => `  <url><loc>${SITE.url}${u}</loc></url>`).join("\n")}\n</urlset>\n`;
  const blob = new Blob([xml], {
    type: "application/xml"
  });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "sitemap.xml";
  a.click();
  URL.revokeObjectURL(a.href);
}
export function Sitemap() {
  useSeo({
    title: "Sitemap",
    description: "Every page on the NEXORA Web Studio website.",
    path: "/sitemap"
  });
  return <>
      <PageHero crumbs={[{
      label: "Sitemap"
    }]} eyebrow="Sitemap" title="Every page, in one place." actions={<button type="button" onClick={downloadXml} className="inline-flex min-h-[52px] items-center gap-2 rounded-full border border-line-strong px-6 text-fg-2 hover:text-fg" data-id="element-963" data-mp="261bvrqx1gkqj">
            <DownloadIcon className="h-4 w-4" data-id="element-964" data-mp="1x16qbmbenwf0" /> Download sitemap.xml
          </button>} data-id="element-962" data-mp="388x4latnh8qa" />
      <section className="shell section auto-grid" style={{
      "--min": "240px"
    } as React.CSSProperties} data-id="element-965" data-mp="2trpgewdanhb3">
        {SITEMAP_GROUPS.map(g => <div key={g.title} data-id="element-966" data-mp="2osml43n48pgb">
            <h2 className="t-eyebrow mb-4 border-b border-line pb-3 text-muted" data-id="element-967" data-mp="2oufkcxveg7ea">{g.title}</h2>
            <ul data-id="element-968" data-mp="2jz0644thc9hc">
              {g.links.map(l => <li key={l.href} data-id="element-969" data-mp="2fypzcpxv5f1f">
                  <Link to={l.href} className="inline-flex min-h-[40px] items-center text-fg-2 hover:text-fg" data-id="element-970" data-mp="2fxop2noo8wkr">{l.label}</Link>
                </li>)}
            </ul>
          </div>)}
      </section>
    </>;
}